var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'bizcomp-safe-center bizcomp ' + _vm.className},[_c('comp-title',{attrs:{"title":_vm.title}}),_c('el-row',_vm._l((_vm.solveLists),function(item,index){return _c('el-col',{key:index,attrs:{"span":24}},[_c('hint-card',{attrs:{"data":item},on:{"btn-click":_vm.loadPage}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }